import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=1866c82e&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=1866c82e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1866c82e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1866c82e')) {
      api.createRecord('1866c82e', component.options)
    } else {
      api.reload('1866c82e', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=1866c82e&scoped=true&", function () {
      api.rerender('1866c82e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/case/inquiry/detail.vue"
export default component.exports